import { GDSColorToken, Prefixed } from '../stitches.config';

type ColorTokenMap = {
  [K in GDSColorToken]: Prefixed<'$', K>;
};

export const colorTokenMap: ColorTokenMap = {
  surfaceBackgroundPrimary: '$surfaceBackgroundPrimary',
  surfaceBackgroundSecondary: '$surfaceBackgroundSecondary',
  surfaceBackgroundTertiary: '$surfaceBackgroundTertiary',
  surfaceCardPrimary: '$surfaceCardPrimary',
  surfaceCardSecondary: '$surfaceCardSecondary',
  surfaceCardDisabled: '$surfaceCardDisabled',
  surfaceScreenHeaderBackground: '$surfaceScreenHeaderBackground',
  surfaceSkeletonShimmerBackground: '$surfaceSkeletonShimmerBackground',
  surfaceSkeletonShimmerOverlay: '$surfaceSkeletonShimmerOverlay',
  onSurfaceTextPrimary: '$onSurfaceTextPrimary',
  onSurfaceTextSubdued: '$onSurfaceTextSubdued',
  onSurfaceTextCritical: '$onSurfaceTextCritical',
  onSurfaceTextSuccess: '$onSurfaceTextSuccess',
  onSurfaceTextWarning: '$onSurfaceTextWarning',
  onSurfaceTextReversed: '$onSurfaceTextReversed',
  onSurfaceBorderSubdued: '$onSurfaceBorderSubdued',
  onSurfaceBorderDefault: '$onSurfaceBorderDefault',
  onSurfaceIconPrimary: '$onSurfaceIconPrimary',
  interactiveActionPrimary: '$interactiveActionPrimary',
  interactiveActionHovered: '$interactiveActionHovered',
  interactiveActionPressed: '$interactiveActionPressed',
  interactiveActionSubdued: '$interactiveActionSubdued',
  interactiveActionDisabled: '$interactiveActionDisabled',
  interactiveBackgroundDefault: '$interactiveBackgroundDefault',
  interactiveBackgroundDisabled: '$interactiveBackgroundDisabled',
  interactiveBackgroundHovered: '$interactiveBackgroundHovered',
  interactiveBackgroundPressed: '$interactiveBackgroundPressed',
  interactiveBorderDefault: '$interactiveBorderDefault',
  interactiveBorderHovered: '$interactiveBorderHovered',
  interactiveBorderDisabled: '$interactiveBorderDisabled',
  interactiveBorderCriticalDefault: '$interactiveBorderCriticalDefault',
  interactiveFocusInner: '$interactiveFocusInner',
  interactiveFocusOuter: '$interactiveFocusOuter',
  interactiveIconDefault: '$interactiveIconDefault',
  interactiveIconDisabled: '$interactiveIconDisabled',
  criticalBackgroundSubdued: '$criticalBackgroundSubdued',
  criticalBackgroundSecondary: '$criticalBackgroundSecondary',
  criticalBorderDefault: '$criticalBorderDefault',
  criticalIcon: '$criticalIcon',
  warningBackgroundSubdued: '$warningBackgroundSubdued',
  warningBackgroundSecondary: '$warningBackgroundSecondary',
  warningBorderDefault: '$warningBorderDefault',
  warningIcon: '$warningIcon',
  successBackgroundSubdued: '$successBackgroundSubdued',
  successBackgroundSecondary: '$successBackgroundSecondary',
  successBorderDefault: '$successBorderDefault',
  successIcon: '$successIcon',
  highlightBackgroundSubdued: '$highlightBackgroundSubdued',
  highlightBackgroundSecondary: '$highlightBackgroundSecondary',
  highlightBorderDefault: '$highlightBorderDefault',
  highlightIcon: '$highlightIcon',
  decorativeBrandPrimaryDarkest: '$decorativeBrandPrimaryDarkest',
  decorativeBrandPrimaryDark: '$decorativeBrandPrimaryDark',
  decorativeBrandPrimaryDefault: '$decorativeBrandPrimaryDefault',
  decorativeBrandPrimaryBright: '$decorativeBrandPrimaryBright',
  decorativeBrandPrimaryBrightest: '$decorativeBrandPrimaryBrightest',
  decorativeBrandPrimaryPastel: '$decorativeBrandPrimaryPastel',
  decorativeBrandSecondaryDarkest: '$decorativeBrandSecondaryDarkest',
  decorativeBrandSecondaryDark: '$decorativeBrandSecondaryDark',
  decorativeBrandSecondaryDefault: '$decorativeBrandSecondaryDefault',
  decorativeBrandSecondaryBright: '$decorativeBrandSecondaryBright',
  decorativeBrandSecondaryBrightest: '$decorativeBrandSecondaryBrightest',
  decorativeBrandSecondaryPastel: '$decorativeBrandSecondaryPastel',
  decorativeBrandTertiaryDarkest: '$decorativeBrandTertiaryDarkest',
  decorativeBrandTertiaryDark: '$decorativeBrandTertiaryDark',
  decorativeBrandTertiaryDefault: '$decorativeBrandTertiaryDefault',
  decorativeBrandTertiaryBright: '$decorativeBrandTertiaryBright',
  decorativeBrandTertiaryBrightest: '$decorativeBrandTertiaryBrightest',
  decorativeBrandTertiaryPastel: '$decorativeBrandTertiaryPastel',
  primaryBackgroundDefault: '$primaryBackgroundDefault',
  primaryBackgroundHovered: '$primaryBackgroundHovered',
  primaryBackgroundPressed: '$primaryBackgroundPressed',
  primaryTextDefault: '$primaryTextDefault',
  primaryBackgroundCriticalDefault: '$primaryBackgroundCriticalDefault',
  primaryBackgroundCriticalHovered: '$primaryBackgroundCriticalHovered',
  primaryBackgroundCriticalPressed: '$primaryBackgroundCriticalPressed',
  primaryTextCriticalDefault: '$primaryTextCriticalDefault',
  secondaryBackgroundDefault: '$secondaryBackgroundDefault',
  secondaryBackgroundHovered: '$secondaryBackgroundHovered',
  secondaryBackgroundPressed: '$secondaryBackgroundPressed',
  secondaryTextDefault: '$secondaryTextDefault',
  secondaryTextHovered: '$secondaryTextHovered',
  secondaryBorderDefault: '$secondaryBorderDefault',
  tertiaryBackgroundDefault: '$tertiaryBackgroundDefault',
  tertiaryBackgroundHovered: '$tertiaryBackgroundHovered',
  tertiaryBackgroundPressed: '$tertiaryBackgroundPressed',
  tertiaryTextDefault: '$tertiaryTextDefault',
  tertiaryTextHovered: '$tertiaryTextHovered',
  tertiaryBorderDefault: '$tertiaryBorderDefault',
  inputBackgroundDefault: '$inputBackgroundDefault',
  inputBackgroundDisabled: '$inputBackgroundDisabled',
  inputBackgroundHovered: '$inputBackgroundHovered',
  inputBackgroundPressed: '$inputBackgroundPressed',
  inputBorderDefault: '$inputBorderDefault',
  inputBorderHovered: '$inputBorderHovered',
  inputBorderDisabled: '$inputBorderDisabled',
  inputBorderCritical: '$inputBorderCritical',
  inputBorderSuccess: '$inputBorderSuccess',
  inputBorderWarning: '$inputBorderWarning',
  dataVizInterfaceTrackBorder: '$dataVizInterfaceTrackBorder',
  dataVizInterfaceTrackBackground: '$dataVizInterfaceTrackBackground',
  dataVizSingleColorBrand: '$dataVizSingleColorBrand',
  dataVizSingleColorNeutral: '$dataVizSingleColorNeutral',
  dataVizStatusCritical: '$dataVizStatusCritical',
  dataVizStatusWarning: '$dataVizStatusWarning',
  dataVizStatusSuccess: '$dataVizStatusSuccess',
  dataVizCategoricalOne: '$dataVizCategoricalOne',
  dataVizCategoricalTwo: '$dataVizCategoricalTwo',
  dataVizCategoricalThree: '$dataVizCategoricalThree',
  dataVizCategoricalFour: '$dataVizCategoricalFour',
  dataVizCategoricalFive: '$dataVizCategoricalFive',
  dataVizCategoricalSix: '$dataVizCategoricalSix',
  tagCriticalBackgroundBold: '$tagCriticalBackgroundBold',
  tagCriticalBackgroundSubdued: '$tagCriticalBackgroundSubdued',
  tagCriticalBorderBold: '$tagCriticalBorderBold',
  tagCriticalBorderSubdued: '$tagCriticalBorderSubdued',
  tagCriticalTextBold: '$tagCriticalTextBold',
  tagCriticalTextSubdued: '$tagCriticalTextSubdued',
  tagFourBackgroundBold: '$tagFourBackgroundBold',
  tagFourBackgroundSubdued: '$tagFourBackgroundSubdued',
  tagFourBorderBold: '$tagFourBorderBold',
  tagFourBorderSubdued: '$tagFourBorderSubdued',
  tagFourTextBold: '$tagFourTextBold',
  tagFourTextSubdued: '$tagFourTextSubdued',
  tagInformationalBackgroundBold: '$tagInformationalBackgroundBold',
  tagInformationalBackgroundSubdued: '$tagInformationalBackgroundSubdued',
  tagInformationalBorderBold: '$tagInformationalBorderBold',
  tagInformationalBorderSubdued: '$tagInformationalBorderSubdued',
  tagInformationalTextBold: '$tagInformationalTextBold',
  tagInformationalTextSubdued: '$tagInformationalTextSubdued',
  tagNeutralBackgroundBold: '$tagNeutralBackgroundBold',
  tagNeutralBackgroundSubdued: '$tagNeutralBackgroundSubdued',
  tagNeutralBorderBold: '$tagNeutralBorderBold',
  tagNeutralBorderSubdued: '$tagNeutralBorderSubdued',
  tagNeutralTextBold: '$tagNeutralTextBold',
  tagNeutralTextSubdued: '$tagNeutralTextSubdued',
  tagOneBackgroundBold: '$tagOneBackgroundBold',
  tagOneBackgroundSubdued: '$tagOneBackgroundSubdued',
  tagOneBorderBold: '$tagOneBorderBold',
  tagOneBorderSubdued: '$tagOneBorderSubdued',
  tagOneTextBold: '$tagOneTextBold',
  tagOneTextSubdued: '$tagOneTextSubdued',
  tagSuccessBackgroundBold: '$tagSuccessBackgroundBold',
  tagSuccessBackgroundSubdued: '$tagSuccessBackgroundSubdued',
  tagSuccessBorderBold: '$tagSuccessBorderBold',
  tagSuccessBorderSubdued: '$tagSuccessBorderSubdued',
  tagSuccessTextBold: '$tagSuccessTextBold',
  tagSuccessTextSubdued: '$tagSuccessTextSubdued',
  tagThreeBackgroundBold: '$tagThreeBackgroundBold',
  tagThreeBackgroundSubdued: '$tagThreeBackgroundSubdued',
  tagThreeBorderBold: '$tagThreeBorderBold',
  tagThreeBorderSubdued: '$tagThreeBorderSubdued',
  tagThreeTextBold: '$tagThreeTextBold',
  tagThreeTextSubdued: '$tagThreeTextSubdued',
  tagTwoBackgroundBold: '$tagTwoBackgroundBold',
  tagTwoBackgroundSubdued: '$tagTwoBackgroundSubdued',
  tagTwoBorderBold: '$tagTwoBorderBold',
  tagTwoBorderSubdued: '$tagTwoBorderSubdued',
  tagTwoTextBold: '$tagTwoTextBold',
  tagTwoTextSubdued: '$tagTwoTextSubdued',
  tagWarningBackgroundBold: '$tagWarningBackgroundBold',
  tagWarningBackgroundSubdued: '$tagWarningBackgroundSubdued',
  tagWarningBorderBold: '$tagWarningBorderBold',
  tagWarningBorderSubdued: '$tagWarningBorderSubdued',
  tagWarningTextBold: '$tagWarningTextBold',
  tagWarningTextSubdued: '$tagWarningTextSubdued',
};
